export default () => ({
  init() {
    this.store = Alpine.store("data")
  },

  getGoalWeightDiff() {
    const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values

    if (this.store.isMetric()) {
      return weightKg - targetWeightKg
    } else {
      return weightLbs - targetWeightLbs
    }
  },

  handleContinue() {
    this.store.internalTracker.trackClick({ clickName: "Continue Clicked" })
    this.store.goToLogin()
  },
})
